'use client'

import { Pets } from '@mui/icons-material'
import { Box, Chip, Stack, Typography } from '@mui/material'
import moment from 'moment'
import { toDollars, TextBlock } from '@wolfdanepug/common-react'

export default function SubscriptionSummary({
	subscription,
	gap = 3,
	title,
	showIcon = true,
	sx = {}
}: any) {
	return (
		<Stack gap={gap} sx={sx.root}>
			<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
				<Box>
					{title && (
						<Typography fontSize={'28px'} variant="h3" sx={sx.title}>
							{title}
						</Typography>
					)}
					<Typography variant="caption" sx={sx.text}>
						Member Since {moment().format('MMMM Do, YYYY')}
					</Typography>
				</Box>
				{showIcon && <Pets sx={sx.icon} />}
			</Box>

			<Chip label="Gourmet Fresh 2 Week" color="primary" sx={{ ...styles.chip, ...sx.chip }} />

			<TextBlock
				sx={{ ...styles.price, ...sx.price }}
				title={`$ ${toDollars(subscription?.price ?? 0)}`}
				text="/ 2 weeks"
			/>
		</Stack>
	)
}

const styles = {
	chip: {
		borderRadius: 1,
		fontSize: '20px',
		textAlign: 'left',
		p: '8px',
		height: 'auto',
		justifyContent: 'flex-start',
		fontWeight: 500
	},
	price: {
		root: {
			flexDirection: 'row',
			alignItems: 'flex-end',
			gap: 1
		},
		title: {
			width: 'auto',
			color: 'primary.main',
			fontSize: '42px',
			fontWeight: 500,
			lineHeight: '42px'
		},
		text: {
			display: 'inline-flex',
			flex: 1
		}
	}
}
